module.exports = __webpack_public_path__ + "./fonts/Proxima-Regular.ttf";